import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=b0eddaea&scoped=true"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./CreateUpdatePage.vue?vue&type=style&index=0&id=b0eddaea&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eddaea",
  null
  
)

export default component.exports